import { useSearchParams } from "react-router";
const queryParamName = "productId";
export function useProductIdFormQueryString() {
  const [searchParams] = useSearchParams();

  const productId = searchParams.get(queryParamName);

  return {
    productId: productId ?? undefined,
  };
}
